import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

export default function Tooltip({ dismissTooltip }: { dismissTooltip: () => void }): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <div className="mmm-tooltip">
        <button
          className="close-tooltip-button"
          onClick={dismissTooltip}
          aria-label="Close tooltip"
        >
          ✕
        </button>
        <div className="tooltip-rectangle" />
        <div className="tooltip-text-header">{t('srp.multiMakeModel.tooltipHeader')}</div>
        <div className="tooltip-text-copy">{t('srp.multiMakeModel.tooltipCopy')}</div>
      </div>
      <style>{`
        .mmm-tooltip {
          background: rgba(0, 0, 0, 0.85);
          border-radius: 8px;
          color: ${colors.G1};
          padding: 16px;
          width: 297px;
          height: 110px;
          position: absolute;
          top: 60px;
          right: 0;
          z-index: 10;
        }

        .mmm-tooltip::before {
          content: '';
          position: absolute;
          top: -17px; /* Adjust this based on the size of your TooltipTip SVG */
          left: 46%; /* Keep the same position as your original triangle */
          width: 24px;
          height: 24px;
          background-image: url('/static/images/srp/tooltip-tip.svg');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        .close-tooltip-button {
          position: absolute;
          top: 14px;
          right: 16px;
          background: transparent;
          border: none;
          color: ${colors.G3};
          cursor: pointer;
          font-size: 16px;
          font-weight: 700;
          padding: 0;
        }

        .tooltip-text-header {
          margin-bottom: 8px;
          font-size: 18px;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0.2px;
        }

        .tooltip-text-copy {
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          letter-spacing: 0.2px;
        }
        `}</style>
    </>
  );
}
